// import slick from 'slick-carousel';

export default (el) => {

  $('.js-slider').slick({
    dots: true,
    appendDots: '.js-slider-dots',
    arrows: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    fade: true,
    autoplay: true,
    autoplaySpeed: 10000,
  });

};
